import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 外部カレンダーイベントの取得
 *
 * 指定された日付の外部カレンダーイベントを取得する
 */
export class FetchCalendarEvents implements APIRequest<Monitaro.FetchCalendarEventsResponse> {
  response: Monitaro.FetchCalendarEventsResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query

  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/calendars/events`
  }
}
